import axios from 'axios';
import { logWarn } from './log';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Auth is handled via an httpOnly cookie (set by the backend). We only need to
// send credentials (cookies) with every request. No token is stored in JS.
const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.response.use(
  (r) => r,
  (err) => {
    const status = err?.response?.status;
    const url = err?.config?.url || '';
    // Session expired / not authenticated: clear the cached profile and send the
    // user to login instead of letting the 401 surface as an uncaught runtime error.
    if (status === 401 && !url.includes('/auth/')) {
      try { localStorage.removeItem('dd_user'); } catch (e) { logWarn('Could not clear cached user', e); }
      if (typeof window !== 'undefined' && !window.location.pathname.startsWith('/login') && !window.location.pathname.startsWith('/signin')) {
        window.location.replace('/signin');
        // Swallow the rejection so it doesn't trigger the dev error overlay while redirecting.
        return new Promise(() => {});
      }
    }
    return Promise.reject(err);
  }
);

export default api;

export const fmtINR = (n) =>
  new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', maximumFractionDigits: 2 }).format(Number(n || 0));
export const fmtNum = (n) => new Intl.NumberFormat('en-IN').format(Number(n || 0));
export const fmtDate = (d) => (d ? new Date(d).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' }) : '-');
export const fmtDateTime = (d) => (d ? new Date(d).toLocaleString('en-IN', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' }) : '-');
